import { z } from 'zod';

import {
  PackageSchemaTypeEnum,
  PackageStatusDetailsLevelEnum,
  PackageStatusDetailsStatusEnum,
  PackageTypeEnum,
} from './enums';

// Zod-side mirrors of the Prisma models used by public type packages.
// These mirror `packages/api/prisma/schema.prisma` without importing Prisma.

const dateLike = z.date().or(z.string());

export const CreatedByModel = z.object({
  id: z.number(),
  accountId: z.string(),
  userId: z.string(),
  createdAt: dateLike,
});

export const CategoryModel = z.object({
  id: z.string(),
  name: z.string(),
  hidden: z.boolean(),
  type: z.nativeEnum(PackageTypeEnum),
  createdById: z.number(),
  modifiedById: z.number(),
  createdAt: dateLike,
  updatedAt: dateLike,
});

export const PackageModel = z.object({
  id: z.string(),
  createdAt: dateLike,
  updatedAt: dateLike,
  createdById: z.number(),
  modifiedById: z.number(),
  type: z.nativeEnum(PackageTypeEnum),
});

// Prisma nullable columns can arrive as null from DB reads or undefined from
// selected/omitted payloads, matching the historical generated schema shape.
export const PackageReleaseModel = z.object({
  revisionId: z.string(),
  id: z.string(),
  createdAt: dateLike,
  createdById: z.number(),
  data: z.any().nullish(),
  membersAccountIds: z.array(z.string()).optional(),
  membersUserIds: z.array(z.string()).optional(),
  meta: z.any(),
  modifiedById: z.number(),
  releaseNotesMarkdown: z.string().trim().nullish(),
  schemaType: z.nativeEnum(PackageSchemaTypeEnum),
  updatedAt: dateLike,
  version: z.string(),
  versionInt: z.string().or(z.bigint()),
  prerelease: z.boolean(),
  type: z.nativeEnum(PackageTypeEnum),
  servingType: z.string().nullish(),
  label: z.string(),
  description: z.string().nullish(),
  fts: z.string().nullish().default(''),
  sourceRevisionId: z.string().nullish(),
});

export const PackageStatusDetailsSystemModel = z.object({
  id: z.number(),
  status: z.nativeEnum(PackageStatusDetailsStatusEnum),
  packageReleaseRevisionId: z.string(),
  createdById: z.number().nullish(),
  modifiedById: z.number().nullish(),
  createdAt: dateLike,
  updatedAt: dateLike,
});

export const PackageStatusDetailsReleaseModel = z.object({
  id: z.number(),
  status: z.nativeEnum(PackageStatusDetailsStatusEnum),
  level: z.nativeEnum(PackageStatusDetailsLevelEnum),
  packageReleaseRevisionId: z.string(),
  createdById: z.number().nullish(),
  modifiedById: z.number().nullish(),
  createdAt: dateLike,
  updatedAt: dateLike,
});
